import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreCustomer } from '@flecto/types'
import { BadgeCustomerVerification, type DataTableColumn } from '@flecto/ui'

import { TextCustomerContacts } from '../TextCustomerContacts/TextCustomerContacts'

export const useColumns = () => {
  const { t } = useTranslation('saas', { keyPrefix: 'customers' })

  const columns: DataTableColumn<CoreCustomer>[] = [
    {
      accessor: 'id',
      title: 'ID',
      width: 70,
      render: (row) => <Text color='dimmed'>{row.internal_id}</Text>,
    },
    {
      accessor: 'full_name',
      title: t('table.name'),
      width: 250,
      render: (row) => (
        <Text truncate fw={500}>
          {row.full_name}
        </Text>
      ),
    },
    {
      accessor: 'contacts',
      title: t('table.contacts'),
      render: (row) => <TextCustomerContacts customer={row} />,
    },
    {
      accessor: 'vat_number',
      title: t('table.vat_number'),
      render: (row) => row.vat_number ?? <Text color='gray'>-</Text>,
    },
    {
      accessor: 'customer_identification',
      title: t('table.customer_identification'),
      render: (row) => {
        return <BadgeCustomerVerification customer={row} />
      },
    },
  ]

  return columns
}
